<template>
    <div class="com-search-bar">
        <Input
            :label="forAgentName"
            ref="name"
            data-key="name"
            @keypress-enter="submit"
            :placeholder="$t('md-team.searchByAgentName')"
        />
        <Input
            :label="forAddress"
            ref="address"
            data-key="address"
            @keypress-enter="submit"
            :placeholder="$t('md-team.searchByAddressCity')"
        />
        <div class="search-button">
            <button @click="submit">
                <i class="iconfont icon-search" v-show="showIcon"></i>{{ $t('md-team.search') }}
            </button>
        </div>
    </div>
</template>

<script>
import Input from './input.vue';
export default {
    emits: ['search'],
    i18next: {
        ns: 'md-team'
    },
    components: { Input },
    data: function() {
        return {};
    },
    props: ['forAgentName', 'forAddress', 'showIcon'],
    methods: {
        submit() {
            this.$emit('search', {
                agentName: this.$refs.name.getValue(),
                address: this.$refs.address.getValue()
            });
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.com-search-bar {
    display: flex;
    flex-wrap: wrap;
    .search-item {
        flex: 1;
        & + .search-item {
            margin-left: 15px;
        }
    }
    input {
        height: 40px;
        width: 100%;
        padding-left: 10px;
        font-size: 14px;
    }
    .search-button {
        margin-left: 15px;
        align-self: flex-end;
    }
    button {
        @include color-button-hover();
        height: 40px;
        line-height: 40px;
        padding: 0 30px;
        @include color-button();
        font-family: var(--font-bold);
    }
    .icon-search {
        margin-right: 10px;
    }

    .label {
        font-size: 14px;
        color: #505050;
        font-family: var(--font-bold);
        width: 100%;
        margin-bottom: 8px;
        display: inline-block;
    }
    @include media-600 {
        .search-item {
            width: 100%;
            flex: none;
            & + .search-item {
                margin-left: 0;
                margin-top: 15px;
            }
        }
        .search-button {
            margin-left: 0;
            margin-top: 20px;
            width: 100%;
        }
        button {
            width: 100%;
        }
        ::-webkit-input-placeholder {
            font-size: 12px;
        }
    }
    .options {
        max-width: 100%;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        transform: translateY(calc(100% + 2px));
        max-height: 200px;
        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
        border: solid 1px #ebecf1;
        z-index: 10;
        overflow-x: hidden;
        overflow-y: auto;
        li {
            height: 40px;
            line-height: 40px;
            font-family: var(--font-normal);
            font-size: 14px;
            color: #191919;
            background-color: #fff;
            padding: 0 10px;
            cursor: pointer;
            &:not(.selected):hover {
                background-color: #f6f7fb;
            }
            &.selected {
                color: var(--color-theme);
            }
            @include ellipsis();
        }
    }
}
</style>
